import { groupBy, identity, reject, filter, prop, __ } from 'ramda'
import { useMemo } from 'react'

import { FinanceReportType as FReport } from 'app/dataTypes/reports/finances'
import { useGeneralSettings } from 'app/dataProviders/generalSettings/hooks'
import { useReportsEnabled } from 'app/dataProviders/reports/hooks'

import { reportsArrange } from './availableReports'

export function useFinancesReportsEnabled() {
  const {
    generalSettings: { eMoneyEnabled },
    loading: loadingGeneralSettings,
  } = useGeneralSettings()

  const { reportsEnabled, loading: loadingReportsEnabled } = useReportsEnabled()

  const reportsEnabledArranged = useMemo(() => {
    const enabledByKey = groupBy(identity, reportsEnabled)
    // @ts-ignore
    const enabledArranged = filter(prop(__, enabledByKey), reportsArrange)

    return eMoneyEnabled
      ? enabledArranged
      : reject(
          (report) => report === FReport.EmoneyLegacy || report === FReport.Emoney,
          enabledArranged,
        )
  }, [reportsEnabled, eMoneyEnabled])

  return {
    reportsEnabled: reportsEnabledArranged,
    loading: loadingReportsEnabled || loadingGeneralSettings,
  }
}
